import { useIntl, type UserAmlQuestionnaireSourcesOfIncome } from '@capsicum/common';
import { amlQuestionnaireReducerAtom } from '@capsicum/features/regulations/shared';
import { useSetAtom } from 'jotai';
import { useEffect, useMemo, useState } from 'react';

type CheckboxDataItem = {
	label: string;
	value: UserAmlQuestionnaireSourcesOfIncome;
};

const SOURCES_OF_INCOME: Array<UserAmlQuestionnaireSourcesOfIncome> = [
	'employment',
	'gifts_donations',
	'investments_cryptotrading',
	'inheritance',
	'savings',
	'winnings',
	'other'
];

export const useAmlSourceOfIncome = () => {
	const { $t } = useIntl();

	const [sourceOfIncome, setSourceOfIncome] = useState<string>('');
	const [choice, setChoice] = useState<Array<UserAmlQuestionnaireSourcesOfIncome>>([]);
	const dispatch = useSetAtom(amlQuestionnaireReducerAtom);

	useEffect(() => {
		dispatch({ data: { sourceOfIncomeOther: sourceOfIncome, sourcesOfIncome: choice }, type: 'UPDATE_FORM_DATA' });

		const isValid = (choice.length > 0 && !choice.includes('other')) || Boolean(sourceOfIncome);

		dispatch({ isValid, stepId: 'SourcesOfIncome', type: 'UPDATE_STEP_VALIDITY' });
	}, [choice, sourceOfIncome]);

	const isOtherSelected = choice.includes('other');

	const handleCheckbox = (checked: boolean, option: UserAmlQuestionnaireSourcesOfIncome) => {
		if (checked) setChoice([...choice, option]);
		else {
			if (option === 'other') setSourceOfIncome('');
			setChoice(choice.filter(item => item !== option));
		}
	};

	const handleInput = (input: string) => setSourceOfIncome(input);

	const checkboxData = useMemo<Array<CheckboxDataItem>>(
		() =>
			SOURCES_OF_INCOME.map(sourceOfIncome => ({
				label: $t(`amlQuestionnaire.fourthStep.${sourceOfIncome}`),
				value: sourceOfIncome
			})),
		[]
	);

	return { checkboxData, handleCheckbox, handleInput, isOtherSelected };
};
